import 'flowbite';
import '../../shared/js/shared.js'

document.documentElement.classList.add('js');

/**
 * Scroll reveal + scroll focus
 */
document.addEventListener('DOMContentLoaded', () => {
    const revealables = document.querySelectorAll('.lyb-reveal');
    const focusables = document.querySelectorAll('.lyb-focus');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Sticky signup bar: functional, so it also runs with reduced motion.
    const stickyBar = document.querySelector('[data-sticky-signup]');
    const hero = document.querySelector('#lyb-hero');

    if (stickyBar && hero) {
        const stickyObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                stickyBar.classList.toggle('translate-y-full', entry.isIntersecting);
            });
        });

        stickyObserver.observe(hero);
    }

    if (reducedMotion) {
        revealables.forEach((element) => element.classList.add('lyb-revealed'));

        return;
    }

    if (revealables.length) {
        const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('lyb-revealed');
                    revealObserver.unobserve(entry.target);
                }
            });
        }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});

        revealables.forEach((element) => revealObserver.observe(element));
    }

    if (focusables.length) {
        const focusObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                entry.target.classList.toggle('lyb-in-focus', entry.isIntersecting);
            });
        }, {rootMargin: '-35% 0px -35% 0px'});

        focusables.forEach((element) => focusObserver.observe(element));
    }
});

/**
 * Timeline
 */
document.addEventListener("DOMContentLoaded", () => {
    const targets = document.querySelectorAll('.lyb-timeline-icon');
    const viewportHeight = window.innerHeight;

    const timelineAnimations = () => {
        targets.forEach(target => {
            const rect = target.getBoundingClientRect();
            if (rect.top < viewportHeight / 2) {
                target.classList.add('past-50');
            } else {
                target.classList.remove('past-50');
                target.style.webkitAnimationPlayState = "running"
            }
        });
    };

    // Initial check in case elements are already past 50% on load
    timelineAnimations();

    // Attach the scroll event listener
    window.addEventListener('scroll', timelineAnimations);
})
